<template>
  <div class="page-main-box pt-24 pr-16">
    <!-- 有数据 -->
    <div class="pl-16">
      <!-- 搜索头 -->
      <search-header :schemaData="schema" @getDataList="handleFormSearch" />

      <!-- 列表 -->
      <div class="table-height" :style="{ height: tableHeight + 'px' }">
        <p-table :dataSource="tableDataSource" height="auto">
          <p-t-column type="seq" width="60" title="序号" />
          <p-t-column field="company_name" min-width="300" title="企业名称">
            <template v-slot="{ row }">
              <span>{{
                row.company_name?.length > 18
                  ? row.company_name?.substr(0, 18) + "..."
                  : row.company_name
              }}</span>
            </template>
          </p-t-column>

          <p-t-column
            field="recharge_amount"
            min-width="150"
            title="充值金额"
            align="right"
          >
            <template v-slot="{ row }">
              <span>{{ (row.recharge_amount / 100).toFixed(2) }}</span>
            </template>
          </p-t-column>
          <p-t-column
            field="payment_amount"
            min-width="150"
            title="消费金额"
            align="right"
          >
            <template v-slot="{ row }">
              <span>{{ (row.payment_amount / 100).toFixed(2) }}</span>
            </template>
          </p-t-column>
          <p-t-column
            field="balance"
            min-width="150"
            title="账户余额"
            align="right"
          >
            <template v-slot="{ row }">
              <span>{{ (row.balance / 100).toFixed(2) }}</span>
            </template>
          </p-t-column>
          <p-t-column
            field="order_count"
            min-width="90"
            title="订单数"
            align="right"
          />
          <p-t-column
            field="oil_quantity"
            min-width="130"
            title="加油量（升）"
            align="right"
          />
          <p-t-column
            field="gas_quantity"
            min-width="130"
            title="加气量（千克）"
            align="right"
          />
          <p-t-column
            field="driver_count"
            min-width="120"
            title="关联司机数"
            align="right"
          />
          <p-t-column width="226" title="操作" fixed="right">
            <template v-slot="{ row }">
              <Button type="link" @click="handleToDetail(row)">
                账户详情
              </Button>
              <Button
                v-if="$store.getters.roles.includes('ConsumerOrders')"
                type="link"
                @click="handleToOrder(row)"
              >
                查看订单
              </Button>
              <Button type="link" @click="handleToDriver(row)">
                查看司机
              </Button>
            </template>
          </p-t-column>
        </p-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, toRaw, onMounted } from "vue";
import { Button } from "ant-design-vue";
import { Table } from "@wlhy-web-components/common";
import { searchHeaderOptions } from "./Constants";
import { useRouter } from "vue-router";
import { useGasCardPageApi } from "@/apis/oil";
import { useCompanyEnumApi } from "@/apis/enums";
import $await from "@/utils/await";
import useTableDataRecords from "@/hooks/useTableDataRecords";
import useSearchForm from "@/hooks/UseSearchForm";
import useSearch from "@/hooks/useSearch";
import useTableHeight from "@/hooks/useTableHeight";
import useDebounce from "@/hooks/useDebounce";

export default {
  name: "enterprise-oil-account",
  components: { Button },
  setup() {
    const router = useRouter();
    const gasCardPageApi = useGasCardPageApi();
    const companyEnumApi = useCompanyEnumApi();

    // table高度
    const tableHeight = ref();

    const tableDataSource = reactive({
      loading: false,
      data: [],
      error: "",
      meta: {
        total: 0,
        pageSize: 20,
        currentPageNo: 1
      },
      sum: {
        data: [],
        loading: false,
        error: ""
      }
    });

    let schemaList = searchHeaderOptions;
    let enumeration = searchHeaderOptions.find(v => v.field === "company_id");

    const handleSearch = useDebounce(async value => {
      const [, res] = await $await(
        companyEnumApi({ name: value, page: 1, size: 100 })
      );
      useSearch(searchHeaderOptions, res, "company_id", false);
    }, 500);
    handleSearch();

    enumeration.props.onSearch = handleSearch;

    const { filter, handleFormSearch } = useSearchForm(schemaList);

    Table.useTableConfig({
      filter,
      dataSource: tableDataSource,
      async fetchData() {
        const data = {
          ...toRaw(filter.value),
          size: tableDataSource.meta.pageSize,
          page: tableDataSource.meta.currentPageNo
        };
        const [, res] = await $await(gasCardPageApi(data));
        return useTableDataRecords(res);
      }
    });

    // 跳转账户详情页
    const handleToDetail = row => {
      router.push({
        path: "/oil/oil-account-detail",
        query: {
          id: row.company_id
        }
      });
    };

    // 跳转查看司机页
    const handleToDriver = row => {
      router.push({
        path: "/oil/driver",
        query: {
          id: row.company_id
        }
      });
    };

    // 跳转到订单页
    const handleToOrder = row => {
      router.push({
        path: "/oil/consumer-orders",
        query: {
          id: row.company_id
        }
      });
    };

    onMounted(() => {
      tableHeight.value = useTableHeight();
    });

    return {
      tableHeight,
      handleToDetail,
      handleToDriver,
      handleToOrder,
      tableDataSource,
      handleFormSearch,
      schema: searchHeaderOptions
    };
  }
};
</script>

<style lang="less" scoped></style>
